import { customerGroupSchema } from "@redotech/redo-model/customers/customer-group-definition";
import { z } from "zod";

export const getCustomerGroups = {
  input: z.object({}),
  output: z.array(customerGroupSchema),
};
